import settingsService from '$shared/services/settingsService';

export enum MatchRelevance {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low'
}

export const MapMatchRelevanceWithHtmlDesc = {
  [MatchRelevance.High]:
    'Matches critical information with a provider;\nhigh likelihood of a match with a provider.',
  [MatchRelevance.Medium]:
    'Matches some information with a provider;\nsome likelihood of a match with a provider.',
  [MatchRelevance.Low]: 'Little information matches a provider;\nunlikely a match with a provider.'
};

export const getAvailableMatchRelevance = (): MatchRelevance[] => {
  const matchRelevancePreference = settingsService.matchRelevancePreference;
  switch (matchRelevancePreference) {
    case MatchRelevance.High: {
      return [MatchRelevance.High];
    }
    case MatchRelevance.Medium: {
      return [MatchRelevance.High, MatchRelevance.Medium];
    }
    case MatchRelevance.Low:
    default: {
      return [MatchRelevance.High, MatchRelevance.Medium, MatchRelevance.Low];
    }
  }
};
